<template>
  <div>
    <b-card style="max-width: 600px; padding: 20px;">
      <p v-if="closeYesterday">
        Toko ditutup secara otomatis setiap harinya pukul 23.30 WIB
      </p>
      <p v-if="!closeYesterday">
        Sebelum melanjutkan transaksi, silakan <b>Tutup Toko</b> terlebih dahulu, karena sistem otomatis tidak berjalan, tutup toko manual untuk tanggal {{ yesterdayDate }} (kemarin).
      </p>
      <b-button
        v-if="$can('read', 'acc-cashflow-list')"
        variant="danger"
        :disabled="closeYesterday"
        @click="handleCloseStore"
      >
        <feather-icon
          icon="ColumnsIcon"
          class="mr-50"
        />
        Tutup Toko
      </b-button>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BButton,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BButton,
  },

  data() {
    return {
      closeYesterday: true, // Flag to check if the store was missed closing
      yesterdayDate: '',
    }
  },

  created() {
    const y = new Date()
    y.setDate(y.getDate() - 1)
    this.yesterdayDate = y.toLocaleDateString('id-ID', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    })

    this.$http.get('/closing/cash/check')
      .then(res => {
        this.closeYesterday = res.data.exists
      })
  },

  mounted() {

  },

  methods: {
    handleCloseStore() {
      this.$http.get('/closing/cash/missed')
        .then(() => {
          this.$router.push({ name: 'dashboard-toko' })
        })
      // Logic to close the store
    },
  },
}
</script>
